import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalBody,
  CLabel,
  CModalFooter,
  CButton,
  CSpinner,
  CFormGroup,
  CInputGroup,
  CTextarea
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./css/content.css";

// O objeto Upload é uma VAGA DE ENTREGA: aqui o professor só descreve o que
// espera receber. Quem manda arquivo é o aluno, por outro caminho
// (UploadModal -> file/uploads-students -> content/upload_user/insert), e a
// correção sai no CorrectUpload.
//
// Já existiu um FilePond nesta tela, mas o link que ele devolvia nunca entrava
// no payload do content/upload/insert — o arquivo ficava órfão no servidor e o
// aluno seguia vendo só a descrição. Pior: era obrigatório, então não dava para
// criar uma vaga sem subir um arquivo que ninguém ia ler. Se um dia o professor
// precisar anexar material de apoio, isso depende do backend guardar e devolver
// o link no content/upload/singleView.
class UploadCreator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      description: "",
      loading: false
    };

    this.handleClose = this.handleClose.bind(this);
  }

  // Vários pais montam este modal uma vez só e alternam `show`, então sem
  // limpar na saída a próxima abertura vem com a descrição da anterior — e um
  // clique em "Inserir" criaria uma vaga duplicada.
  handleClose() {
    this.setState({ description: "", loading: false });
    this.props.onClose();
  }

  insertUpload() {
    if (this.state.description === "") {
      toastr.warning("Atenção", "Preencha o campo de descrição!");
      return;
    }

    let obj = {
      description: this.state.description,
      extensions: "*",
      user_id: this.props.user.user.id
    };

    this.setState({ loading: true });

    axios
      .post(`${URL.api}content/upload/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ loading: false });
          this.props.getContent({
            type: 18,
            list: [{ id: resp.data.data, name: "Upload" }]
          });
          this.handleClose();
        },
        error => {
          // Sem aviso o spinner apenas parava e o professor achava que salvou.
          this.setState({ loading: false });
          toastr.error(
            "Falha",
            "Não foi possível criar o upload. Tente novamente!"
          );
        }
      );
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        onClose={this.handleClose}
        centered
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Inserir upload</CModalHeader>
        <CModalBody>
          <CFormGroup>
            <CLabel>Descrição</CLabel>
            <CInputGroup>
              <CTextarea
                rows={4}
                value={this.state.description}
                onChange={e => this.setState({ description: e.target.value })}
                placeholder="Descreva o que o aluno deve enviar"
              />
            </CInputGroup>
            <small className="form-text text-muted">
              O aluno verá esta descrição e enviará o arquivo dele ao abrir a
              atividade.
            </small>
          </CFormGroup>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            disabled={this.state.loading}
            onClick={() => this.insertUpload()}
          >
            <>
              <span style={this.state.loading ? { opacity: 0 } : null}>
                Inserir
              </span>
              {this.state.loading && (
                <CSpinner
                  size="sm"
                  color="white"
                  style={{ position: "absolute" }}
                />
              )}
            </>
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadCreator);
